var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('formar-header',{staticClass:"sticky-element"}),_c('router-view'),_c('formar-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }